export const de = {
    "these_zesty_duck_nudge": "Allgemeine Informationen",
    "north_least_gopher_burn": "Was ist der Zweck dieser Terminart?",
    "lazy_just_duck_spin": "Titel des Events",
    "Confirm meeting": "Termin bestätigen",
    "Meeting with {{name}}": "Termin mit {{name}}",
    "Daily availability": "Tägliche Verfügbarkeit",
    "tiny_factual_platypus_pave": "Wo findet das Meeting statt?",
    "less_equal_octopus_dine": "Anpassbarer Teil der URL",
    "quiet_male_yak_slurp": "Kurz-URL",
    "dizzy_quiet_walrus_hush": "mein-termin",
    "quaint_known_wasp_view": "Minimaler Vorlauf (Tage)",
    "pretty_grand_cuckoo_arrive": "Minimaler Vorlauf, mit dem ein Termin gebucht werden kann.",
    "slow_maroon_spider_praise": "Maximale Anzahl an Terminen dieses Typs, die pro Tag gebucht werden können.",
    "grand_wacky_ox_flow": "Maximale Anzahl pro Tag",
    "left_aloof_stork_leap": "Vorlaufpuffer",
    "elegant_early_boar_accept": "Wie lange dauert diese Terminart?",
    "ideal_this_coyote_inspire": "Dauer",
    "jumpy_tasty_rook_trust": "Dauer",
    "real_big_crow_push": "Pufferzeit vor dieser Terminart",
    "mealy_happy_ray_flop": "Vorlaufpuffer",
    "close_actual_deer_boil": "Anschlusspuffer",
    "keen_zippy_bulldog_gaze": "Puffer nach dieser Terminart",
    "seemly_fine_octopus_slurp": "Verfügbarkeit",
    "each_awake_tadpole_jest": "Terminart bearbeiten",
    "extra_patient_warbler_praise": "Keine buchbaren Termine",
    "petty_swift_piranha_rise": "Termin vereinbaren",
    "broad_close_butterfly_drop": "Vereinbaren Sie einen Termin mit {{name}}",
    "weary_known_gazelle_file": "Bitte wählen Sie die gewünschte Terminart. Sie erhalten eine Liste der verfügbaren Termine in meinem Zeitplan.",
    "low_clean_haddock_bubble": "Meine Terminarten",
    "My Event Types": "Meine Terminarten",
    "pink_trite_ocelot_enrich": "Sie müssen zuerst Ihren Kalender verbinden, bevor Sie Ereignisse hinzufügen können!",
    "early_sweet_mantis_peek": "Veranstaltungstyp hinzufügen",
    "deft_suave_bear_pause": "Termine werden geladen ...",
    "equal_jolly_thrush_empower": " Minuten",
    "Schedule an appointment": "Termin vereinbaren",
    "heroic_kind_llama_zip": "Zurück",
    "awake_jolly_gazelle_lock": "Überspringen",
    "whole_acidic_parrot_promise": "Termin buchen",
    "clear_close_racoon_pat": "{{value, dateTime}}",
    "cuddly_spare_felix_stir": "Schritt {{val}}",
    "extra_misty_panda_grip": "Über diesen Link können Nutzer Termine buchen.",
    "sunny_great_halibut_empower": "Erstelle den ersten",
    "create_first_event_type_button": "Veranstaltungstypen",
    "application_title": "Appoint Me",
    "orange_grand_racoon_fall": "Wie {{app_title}} funktioniert",
    "male_patient_hedgehog_ask": "{{app_title}} ist eine einfache und benutzerfreundliche Terminverwaltung. Erstellen Sie Ereignisse, teilen Sie Ihren Link und lassen Sie andere Termine mit Ihnen buchen.",
    "factual_moving_hawk_belong": "Legen Sie fest, wo {{app_title}} Termine eintragen und wo Ihre Verfügbarkeit geprüft werden soll.",
    "step_1_configure_calendars": "Schritt 1: Kalender konfigurieren",
    "pink_polite_racoon_earn": "Schritt 2: Ereignisse erstellen",
    "happy_wise_mantis_laugh": "Fügen Sie Ihre verfügbaren Zeiten hinzu und legen Sie los!",
    "careful_misty_bullock_splash": "Schritt 3: Teilen Sie Ihren Link",
    "game_frail_vole_treasure": "Erledigt! Glückwunsch!",
    "still_helpful_koala_trust": "Sobald ein Benutzer einen Termin bucht, wird das Ereignis Ihrem Kalender hinzugefügt.",
    "steep_fine_lobster_inspire": "Terminart konnte nicht gespeichert werden",
    "best_due_parakeet_zip": "Terminart angelegt",
    "happy_caring_fox_spur": "Terminart gespeichert",
    "tasty_witty_stingray_hope": "Fehler beim Speichern der Terminart",
    "trite_warm_gorilla_pet": "Termine zum Kalender hinzufügen",
    "aware_alert_mare_glow": "Freie Zeit in Kalendern prüfen",
    "factual_nimble_snail_clap": "Änderungen speichern",
    "tiny_teary_clownfish_vent": "Abbrechen",
    "lower_born_finch_dash": "Google-Kalender trennen",
    "whole_formal_liger_rise": "Google-Kalender verbinden",
    "pink_loose_cougar_grin": "Mein Kalender",
    "upper_even_florian_peek": "Google Kalender",
    "merry_north_meerkat_cuddle": "Konfiguration",
    "big_known_loris_revive": "Wählen Sie Kalender aus, um nach belegten Zeiten zu suchen.",
    "large_suave_gull_hush": "Link kopieren",
    "misty_proud_mallard_assure": "Link kopieren",
    "Name": "Name",
    "Please provide your name": "Bitte geben Sie Ihren Namen an",
    "Email": "E-Mail-Adresse",
    "You will receive a confirmation email": "Sie erhalten eine Terminbestätigung via E-Mail",
    "Information": "Informationen zu Ihrem Anliegen",
    "Please share anything that will help me to prepare for our meeting": "Ihre Angaben helfen mir bei der Vorbereitung unseres Meetings",
    "Meeting with": "Meeting mit",
    "Change": "ändern",
    "Back": "Zurück",
    "Add Event Type": "Terminart hinzufügen",
    "Confirm & Book": "Termin bestätigen",
    "Confirmation": "Bestätigung",
    "confirmationText_female": "Sie haben eine {{event}} mit {{name}} am {{date}} um {{time}} Uhr gebucht.",
    "confirmationText_male": "Sie haben einen {{event}} mit {{name}} am {{date}} um {{time}} Uhr gebucht.",
    "confirmationText_neuter": "Sie haben ein {{event}} mit {{name}} am {{date}} um {{time}} Uhr gebucht.",
    "availableSlots": "Am {{date}} sind die folgenden Termine verfügbar. Reservieren Sie einen oder wählen Sie einen anderen Tag.",
    "minutes": "Minuten",
    "Choose date": "Datum wählen",
    "Please select a date": "Bitte wählen Sie ein Datum",
    "Choose time": "Uhrzeit wählen",
    "Provide details": "Details angeben",
    "teal_lofty_hawk_peek": "Abbrechen",
    "mild_raw_elk_delight": "Änderungen speichern",
    "Days": "Tage",
    "Maximum days in advance": "Maximaler Vorlauf (Tage)",
    "event_advance_availability_description": "Wie viele Tage im Voraus ist diese Terminart verfügbar?",
    "none": "Keiner",
    "edit": "Bearbeiten",
    "Select buffer": "Puffer wählen",
    "Save": "Speichern",
    "Select duration": "Dauer wählen",
    "Starttime": "Startzeit",
    "Endtime": "Endzeit",
    "these_moving_fox_create": "Beschreibung",
    "honest_weak_iguana_rest": "Ort",
    "tired_whole_bumblebee_type": "z.B. Online via Zoom",
    "Add Account": "Konto hinzufügen",
    "Add CalDav Account": "CalDav Konto hinzufügen",
    "CalDav Accounts": "CalDav Konten",
    "Server URL": "Server URL",
    "Username": "Benutzername",
    "label_password": "Passwort",
    "Notice": "Hinweis",
    "No slots available for the selected period.": "Für den ausgewählten Zeitraum sind keine Termine verfügbar.",
    "send_invitation_email": "Einladungs-E-Mail senden",
    "send_invitation_email_notice": "Nur erforderlich, wenn Ihr CalDAV-Server keine Einladungen automatisch versendet.",
    "invitationSubject": "Einladung: {{summary}}",
    "invitationBody": "<p>Hallo {{attendeeName}},</p><p>Du wurdest zu folgendem Termin eingeladen:</p><h3>{{summary}}</h3><p>{{description}}</p><p><strong>Zeit:</strong> {{time}}</p><p>Anbei findest du die Termindetails.</p>",
    "icsDescription": "Terminbeschreibung:\n{{description}}",
    "dateFormat": "de-DE",
    "user_menu_log_out": "Abmelden",
    "user_menu_log_in": "Anmelden",
    "user_menu_profile": "Profil",
    "user_menu_my_account": "Mein Konto",
    "user_menu_calendar_integration": "Kalenderintegration",
    "user_menu_copy_link": "Link kopieren",
    "user_menu_link_copied": "Link kopiert",
    "name": "Name",
    "user_url": "Benutzer-URL",
    "use_gravatar": "Gravatar verwenden",
    "save": "Speichern",
    "profile_updated": "Profil erfolgreich aktualisiert",
    "error_saving_profile": "Fehler beim Speichern des Profils",
    "user_url_taken": "Benutzer-URL bereits vergeben",
    "error_loading_profile": "Fehler beim Laden des Profils",
    "login_with_sso": "Anmelden mit SSO",
    "login_with": "Anmelden mit",
    "login_successful": "Anmeldung erfolgreich",
    "login_failed": "Anmeldung fehlgeschlagen",
    "google_login_failed": "Google-Anmeldung fehlgeschlagen",
    "Feedback": "Feedback",
    "Add": "Hinzufügen",
    "Close": "Schließen",
    "I acknowledge that my password will be stored encrypted in the database.": "Ich bestätige, dass mein Passwort verschlüsselt in der Datenbank gespeichert wird.",
    "event_copy_link": "Link kopieren",
    "link_copied_to_clipboard": "Link in die Zwischenablage kopiert!",
    "link_copy_failed": "Link konnte nicht in die Zwischenablage kopiert werden!",
    "copy": "Kopieren",
    "Availability Mode": "Verfügbarkeitsmodus",
    "Define Custom": "Benutzerdefiniert",
    "Use Standard": "Standard verwenden",
    "Standard + Extra": "Standard + Extras",
    "Standard + Constraints": "Standard + Einschränkungen",
    "Standard Availability": "Standardverfügbarkeit",
    "Using Standard Availability defined in Profile settings.": "Verwendet die in den Profileinstellungen definierte Standardverfügbarkeit.",
    "Define your standard weekly availability here. You can use this availability in your Event Types.": "Definieren Sie hier Ihre standardmäßige wöchentliche Verfügbarkeit. Sie können diese Verfügbarkeit in Ihren Ereignistypen verwenden.",
    "Copy Standard Availability": "Standardverfügbarkeit kopieren",
    "Overwrite current availability with standard?": "Aktuelle Verfügbarkeit mit Standard überschreiben?",
    "Profile": "Profil",
    "about": "Über",
    "about_content": `
# Über AppointMe

AppointMe ist ein einfaches Tool zur Terminvereinbarung.
Konfiguriere Deine Kalender, lege Deine Verfügbarkeit fest und lass andere Termine mit Dir vereinbaren.

## Github
[Schau dir den Code auf Github an](https://github.com/fhswf/appointme)

## Credits
Programmiert mit ❤️ an der Fachhochschule Südwestfalen`,
    "legal": "Rechtliches",
    "Calendar": "Kalender",
    "Select a calendar": "Kalender auswählen",
    "No calendar selected": "Kein Kalender ausgewählt",
    "Choose calendars in which appointments are created.": "Wählen Sie Kalender aus, in denen Termine erstellt werden.",
    "Calendar settings saved": "Kalendereinstellungen gespeichert",
    "Failed to save settings": "Einstellungen konnten nicht gespeichert werden",
    "Failed to load calendars for": "Fehler beim Laden der Kalender für",
    "Google Calendar disconnected": "Google Kalender getrennt",
    "Failed to disconnect Google Calendar": "Google Kalender konnte nicht getrennt werden",
    "Connect a calendar to get started": "Verbinden Sie einen Kalender, um zu beginnen",
    "Enter your CalDav server details to connect your calendar.": "Geben Sie Ihre CalDAV-Serverdaten ein, um Ihren Kalender zu verbinden.",
    "Failed to add account. Please check your credentials and server URL.": "Konto konnte nicht hinzugefügt werden. Bitte überprüfen Sie Ihre Zugangsdaten und die Server-URL.",
    "Email (Optional)": "E-Mail (Optional)",
    "Online via Zoom": "Online via Zoom",
    "Language": "Sprache",
    "page not found": "Seite nicht gefunden",
    "GO HOME": "ZUR STARTSEITE",
    "Impressum": "Impressum",
    "Datenschutzhinweise": "Datenschutzhinweise",
    "privacy_content": `
# Datenschutzhinweise

## Datenerhebung und -nutzung
Diese Anwendung erhebt und nutzt personenbezogene Daten, um Terminbuchungsdienste bereitzustellen.

*   **Benutzerprofil:** Wir speichern Ihren Namen, Ihre E-Mail-Adresse und Ihr Profilbild, um Sie zu identifizieren und Ihr Nutzererlebnis zu personalisieren.
*   **Google-Nutzerdaten:** Wenn Sie Ihren Google Kalender verbinden, greifen wir auf Ihre Kalenderdaten zu, um:
    *   Ihre Verfügbarkeit zu prüfen und Doppelbuchungen zu vermeiden.
    *   Neue Termine in Ihrem Kalender zu erstellen, wenn ein Termin gebucht wird.
    *   Wir nutzen Ihre Google Kalenderdaten **nicht** für andere Zwecke, wie z.B. Werbung oder Marktforschung.
*   **Kalenderdaten:** Wir speichern Konfigurationseinstellungen für Ihre verbundenen Kalender, von Ihnen erstellte Terminarten (Name, Beschreibung, Ort) und Terminbuchungen.
*   **Protokolldaten:** Ihre IP-Adresse wird vorübergehend in Server-Logdateien zu Sicherheits- und Fehlerbehebungszwecken gespeichert.
*   **Telemetrie:** Wir erfassen anonyme Nutzungsdaten und Fehlerberichte mit Sentry, um die Stabilität der Anwendung zu verbessern.

## Datenweitergabe
Wir geben Ihre personenbezogenen Daten nicht an Dritte weiter, es sei denn, dies ist zur Bereitstellung des Dienstes erforderlich oder gesetzlich vorgeschrieben.

*   **Google-Nutzerdaten:** Daten, die über Google APIs erhalten wurden, werden **nicht** an Tools von Drittanbietern, KI-Modelle oder externe Entitäten weitergegeben, außer dies ist zur Bereitstellung der Kalenderintegrationsfunktionen erforderlich (z.B. Kommunikation mit Google-Servern).
*   **Dienstleister:** Wir nutzen Sentry für Fehlerverfolgung und Anwendungsüberwachung, um die Dienststabilität sicherzustellen. Dieser Anbieter kann IP-Adressen und andere technische Daten streng zweckgebunden zur Dienstbereitstellung verarbeiten.
*   **Hosting:** Die Anwendung wird auf unserer eigenen Infrastruktur (Kubernetes-Cluster) gehostet. Wir nutzen keine CDNs oder Hosting-Anbieter von Drittanbietern, die dadurch Zugriff auf Ihre Daten erhalten.

## Datenspeicherung und -schutz
Ihre Daten werden sicher auf unseren Servern gespeichert.
*   **Verschlüsselung:** Alle Daten, die zwischen Ihrem Browser und unseren Servern übertragen werden, sind mittels HTTPS verschlüsselt. Sensible Daten wie Zugriffstoken werden verschlüsselt in unserer Datenbank gespeichert.
*   **Zugriffskontrolle:** Der Zugriff auf Ihre Daten ist auf autorisiertes Personal beschränkt und erfolgt nur, wenn dies für Support oder Wartung erforderlich ist.

## Datenspeicherung und Löschung
*   **Aufbewahrung:** Wir bewahren Ihr Benutzerprofil und Ihre Kalenderkonfigurationsdaten so lange auf, wie Ihr Konto aktiv ist. Termindaten werden aufbewahrt, um Ihnen eine Historie Ihrer geplanten Termine bereitzustellen.
*   **Löschung:** Sie haben das Recht, die Löschung Ihrer Daten zu verlangen. Sie können Ihren Google Kalender jederzeit über die Anwendungseinstellungen trennen, wodurch unser Zugriff auf Ihre Google-Daten entfernt wird. Um die vollständige Löschung Ihres Kontos und Ihrer Daten zu beantragen, kontaktieren Sie uns bitte unter gawron.christian@fh-swf.de oder nutzen Sie die Funktion zum Löschen des Kontos in Ihren Profileinstellungen.

## Google API Services User Data Policy
Die Nutzung der Google Calendar API und die Verwendung der erhaltenen Informationen erfolgen in Übereinstimmung mit der [Google API Services User Data Policy](https://developers.google.com/terms/api-services-user-data-policy), einschließlich der Anforderungen an die eingeschränkte Nutzung.`,
    "privacy_content_public": `
# Datenschutzhinweise

## Datenverarbeitung

Zum Zwecke der Terminbuchung verarbeitet diese Anwendung die von Ihnen bereitgestellten Daten (Name, E-Mail-Adresse, Beschreibung, Datum und Uhrzeit des Termins). Diese Daten werden gespeichert, um den Termin zu verwalten, und können mit dem Kalender des Organisators synchronisiert werden.

## Telemetrie

Wir verwenden Sentry, um anonyme Telemetriedaten und Fehlerberichte zu sammeln und die Stabilität der Anwendung zu verbessern.`,
    "impressum_content": "# Impressum\n\n## Disclaimer\nDie Inhalte auf diesem Server gehören nicht zum offiziellen Onlineangebot der Fachhochschule Südwestfalen.",
    "CalDav Calendar": "CalDav Kalender",
    "loading": "Laden...",
    "Legal": "Rechtliches",
    "new_event_type": "Neuer Ereignistyp",
    "Appointment Summary": "Terminzusammenfassung",
    "Could not book event": "Termin konnte nicht gebucht werden",
    "error_no_calendar": "Keine Kalenderintegration konfiguriert",
    "error_no_duration": "Dauer muss größer als 0 sein",
    "error_no_slots": "Keine Zeitfenster konfiguriert",
    "Active": "Aktiv",
    "Inactive": "Inaktiv",
    "delete": "Löschen",
    "Continue": "Weiter",
    "Book Appointment": "Termin buchen",
    "Available Times": "Verfügbare Zeiten",
    "No slots available": "Keine Zeiten verfügbar",
    "Schedule Appointment": "Termin vereinbaren",
    "Available Meeting Types": "Verfügbare Terminarten",
    "Please select a meeting type to view availability.": "Bitte wählen Sie eine Terminart aus, um die Verfügbarkeit anzuzeigen.",
    "All": "Alle",
    "No public events found.": "Keine öffentlichen Termine gefunden.",
    "Timezone": "Zeitzone",
    "Privacy & Terms": "Datenschutz",
    "Quick": "Schnell",
    "Consulting": "Beratung",
    "Tags": "Tags",
    "Type a tag and press Enter": "Tag eingeben und Enter drücken",
    "Press Enter to add a tag": "Drücken Sie Enter, um einen Tag hinzuzufügen",
    "Cancel": "Abbrechen",
    "landing_hero_title": "Terminverwaltung <span class=\"text-primary\">einfach gemacht</span>",
    "landing_hero_subtitle": "Appoint Me ist eine einfache und benutzerfreundliche Lösung für Ihre Termine. Erstellen Sie Ereignisse, teilen Sie Ihren Link und lassen Sie andere Termine mit Ihnen buchen.",
    "landing_cta_start": "Jetzt starten",
    "landing_cta_learn_more": "Mehr erfahren",
    "landing_how_it_works_title": "Wie Appoint Me funktioniert",
    "landing_how_it_works_subtitle": "In nur vier einfachen Schritten zu Ihrem organisierten Kalender.",
    "landing_step1_title": "1. Kalender konfigurieren",
    "landing_step1_desc": "Legen Sie fest, wo Appoint Me Termine eintragen und wo Ihre Verfügbarkeit geprüft werden soll. Verbinden Sie Ihren Google oder Outlook Kalender.",
    "landing_step2_title": "2. Ereignisse erstellen",
    "landing_step2_desc": "Fügen Sie Ihre verfügbaren Zeiten hinzu, definieren Sie Dauer und Pausenzeiten und legen Sie los!",
    "landing_step3_title": "3. Teilen Sie Ihren Link",
    "landing_step3_desc": "Über Ihren persönlichen Link können Kunden, Kollegen oder Freunde direkt Termine buchen, ohne lästiges E-Mail-Pingpong.",
    "landing_step4_title": "Erledigt! Glückwunsch!",
    "landing_step4_desc": "Sobald ein Benutzer einen Termin bucht, wird das Ereignis automatisch Ihrem Kalender hinzugefügt und beide erhalten eine Bestätigung.",
    "landing_footer_product": "Produkt",
    "landing_footer_features": "Features",
    "landing_footer_pricing": "Preise",
    "landing_footer_integrations": "Integrationen",
    "landing_footer_resources": "Ressourcen",
    "landing_footer_documentation": "Dokumentation",
    "landing_footer_api": "API",
    "landing_footer_help_center": "Hilfe Center",
    "landing_footer_legal": "Rechtliches",
    "landing_footer_imprint": "Impressum",
    "landing_footer_privacy": "Datenschutz",
    "landing_footer_terms": "AGB",
    "landing_footer_copyright": "© 2026 Fachhochschule Südwestfalen",
    "landing_footer_tagline": "Einfache Terminplanung für alle.",
    "Contact": "Kontakt",
    "welcome_back": "Willkommen zurück",
    "login_subtitle": "Bitte melden Sie sich an, um fortzufahren.",
    "login_tos_prefix": "Durch die Anmeldung akzeptieren Sie unsere",
    "terms_of_service": "Nutzungsbedingungen",
    "help": "Hilfe",
    "privacy": "Datenschutz",
    "imprint": "Impressum",
    "or": "oder",
    "google": "Google",
    "sso_icon_alt": "SSO Icon",
    "SSO": "SSO",
    "footer_credits": "Programmiert mit ❤️ an der Fachhochschule Südwestfalen",
    "terms_of_use_title": "Nutzungsbedingungen",
    "terms_of_use_content": "# Nutzungsbedingungen\n\n## Leistungserbringung\n\nDieser Dienst wird kostenlos zur Verfügung gestellt.\n\n## Haftungs- und Gewährleistungsausschluss\n\nWeder die Autoren noch die Fachhochschule Südwestfalen übernehmen eine Haftung für Schäden jeglicher Art oder eine Gewährleistung jeglicher Art im Zusammenhang mit der Nutzung dieses Dienstes. Die Nutzung erfolgt auf eigene Gefahr. Dieser Ausschluss gilt nicht für Schäden aus der Verletzung des Lebens, des Körpers oder der Gesundheit, die auf einer vorsätzlichen oder fahrlässigen Pflichtverletzung beruhen, sowie für sonstige Schäden, die auf einer vorsätzlichen oder grob fahrlässigen Pflichtverletzung beruhen.",
    "appointment_details": "Termindetails",
    "close": "Schließen",
    "event_type": "Terminart",
    "week": "Woche",
    "work_week": "Arbeitswoche",
    "day": "Tag",
    "month": "Monat",
    "today": "Heute",
    "agenda": "Agenda",
    "more": "mehr",
    "next": "Weiter",
    "back": "Zurück",
    "my_appointments": "Meine Termine",
    "no_upcoming_appointments": "Keine anstehenden Termine gefunden.",
    "appointment": "Termin",
    "attendee": "Teilnehmer",
    "n_more": "{{count}} weitere ...",
    "Grammatical Gender": "Grammatikalisches Geschlecht",
    "Male": "Männlich (der {{name}})",
    "Female": "Weiblich (die {{name}})",
    "Neuter": "Sächlich (das {{name}})",
    "gender_help_text": "Wird für die korrekte Anrede in Bestätigungen verwendet (z.B. 'Ihr Termin' vs 'Ihre Sprechstunde').",
    "Recurrence": "Wiederholung",
    "Enable Recurring Event": "Wiederkehrenden Termin aktivieren",
    "Frequency": "Häufigkeit",
    "Weekly": "Wöchentlich",
    "Bi-weekly": "Zweiwöchentlich",
    "Tri-weekly": "Dreiwöchentlich",
    "Monthly": "Monatlich",
    "End Condition": "Endbedingung",
    "Occurrences": "Vorfälle",
    "OR": "ODER",
    "Until Date": "Bis Datum",
    "Time Span": "Zeitspanne",
    "Months": "Monate",
    "Weeks": "Wochen",
    "Recurring Event": "Wiederkehrender Termin",
    "Recurring": "Wiederkehrend",
    "weekly": "Wöchentlich",
    "biweekly": "Zweiwöchentlich",
    "triweekly": "Dreiwöchentlich",
    "monthly": "Monatlich",
    "Series Booking Note: Students will book all occurrences at once.": "Hinweis zur Serienbuchung: Teilnehmer buchen alle Termine auf einmal.",
    "Student Only": "Nur für Studierende",
    "Restricted to Students": "Auf Studierende beschränkt",
    "Settings exported successfully": "Einstellungen erfolgreich exportiert",
    "Failed to export settings": "Fehler beim Exportieren der Einstellungen",
    "Are you sure you want to import settings? This will overwrite your current profile and events.": "Sind Sie sicher, dass Sie Einstellungen importieren möchten? Dies überschreibt Ihr aktuelles Profil und Ihre Termine.",
    "Settings imported successfully": "Einstellungen erfolgreich importiert",
    "Failed to import settings": "Fehler beim Importieren der Einstellungen",
    "Invalid file format": "Ungültiges Dateiformat",
    "Data": "Daten",
    "Export Settings": "Einstellungen exportieren",
    "Download your settings and events as a JSON file.": "Laden Sie Ihre Einstellungen und Termine als JSON-Datei herunter.",
    "Export Data": "Daten exportieren",
    "Import Settings": "Einstellungen importieren",
    "Restore your settings from a JSON file. This will overwrite existing data.": "Stellen Sie Ihre Einstellungen aus einer JSON-Datei wieder her. Dies überschreibt vorhandene Daten.",
    "Select File": "Datei auswählen",
    "Online Meeting": "Online-Meeting",
    "You are logged in via your Learning Management System. Please use the specific booking links provided in your course to book appointments.": "Sie sind über Ihr Lernmanagementsystem angemeldet. Bitte nutzen Sie die spezifischen Buchungslinks in Ihrem Kurs, um Termine zu buchen.",
    "Logout": "Abmelden",
    "MyProvider": "Mein Anbieter",
    "Changelog": "Changelog",
    "Failed to load changelog data.": "Die Changelog-Daten konnten nicht geladen werden.",
    "See what's new and what has been fixed.": "Sehen Sie, welche neuen Features es gibt und welche Fehler behoben wurden.",
    "Reminder setting": "Erinnerungseinstellung",
    "Notification type": "Benachrichtigungstyp",
    "System notification": "Systembenachrichtigung",
    "No reminder": "Keine Erinnerung",
    "Reminder time": "Erinnerungszeit",
    "Reminder settings saved": "Erinnerungseinstellungen gespeichert",
    "At event start": "Beim Terminstart",
    "minutes before": "Minuten vorher",
    "1 day before": "1 Tag vorher",
    "days before": "Tage vorher",
    "1 hour before": "1 Stunde vorher",
    "hours before": "Stunden vorher"
};
//# sourceMappingURL=de.js.map